import { IAutomationAppComponent } from "../../types";
import { schema } from "./types";
import { OverviewPanel,OperatorPanel } from '.';
import InsightsPanel from "./InsightsPanel";

export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: null,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    InsightsPanel: InsightsPanel,
    SideViewPanel: InsightsPanel,
    createConfig:     {
        group: 'Devices',
        name: "Multi state display",
        description: "Multi state",
        panel: OverviewPanel,
        defaultState: {  actStateText: "ON" }
    },
}